import React from 'react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { pt } from 'date-fns/locale';

import { isValidPickerValue } from '../utils/dateUtils';

const DayDatePicker = ({
    disabled = false,
    fullWidth = false,
    id,
    label = 'Data',
    maxDate,
    minDate,
    onChange,
    required = false,
    value
}) => (
    <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
        <DatePicker
            label={label}
            value={value}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            onChange={(newValue, context) => {
                if (isValidPickerValue(newValue, context)) {
                    onChange(newValue);
                }
            }}
            slotProps={{
                openPickerButton: { color: 'primary' },
                textField: { id, required, fullWidth }
            }}
        />
    </LocalizationProvider>
);

export default DayDatePicker;
